"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./EventsApiClient"));
var UuidV4_1 = require("./model/types/UuidV4");
exports.UuidV4 = UuidV4_1.UuidV4;
//# sourceMappingURL=Index.js.map